/* eslint-disable import/no-unresolved */
import classnames from 'classnames'
import { Component } from 'preact'
import { connect } from 'react-redux'
import { route } from 'preact-router'
import { getP } from 'redux-polyglot'
import { Link } from 'preact-router/match'
import { debounce } from 'debounce'

import {
  focusInput,
  register,
  reset,
  setStatus,
  updateInput,
  verifyEmail,
  verifyRefferalId,
  verifyUsername,
  verifyPassword,
  verifyPhone,
  isDisabledRegister,
} from 'actions/register'
import {
  REGISTER_INPUT_EMAIL,
  REGISTER_INPUT_PASSWORD,
  REGISTER_INPUT_USERNAME,
  REGISTER_INPUT_REFFERAL_ID,
  REGISTER_INPUT_PHONE,
  REGISTER_STATUS_FAILED,
  REGISTER_STATUS_PROCESSING,
  REGISTER_STATUS_SUCCESS,
  REGISTER_STATUS_WAITING,
} from 'constants/register'
import { getAppName, isLoggedIn, selectRemoveRegister } from 'selectors/app'
import {
  getEmail,
  getEmailError,
  getFocusedInput,
  getPassword,
  getStatus,
  getUsername,
  getUsernameError,
  getRefferalId,
  getPhone,
  getPasswordErrMessage,
  getPhoneErrMessage,
  getUsernameErrMessage,
  getEmailErrMessage,
  getRefferalIdMessage,
  getDisableButton,
} from 'selectors/register'
import AppBar from 'components/app-bar'
import Modal from 'components/modal'
import modalStyles from 'components/styles/modal.css'
import styles from 'components/styles/register.css'
import Redirect from 'components/common/redirect'
import SocialAuth from 'components/social-auth'
import Recaptcha from 'components/recaptcha'
import ListingText from './ListingText'
import { gaPageView } from 'libs/gaPageView'

class Register extends Component {
  state = {
    focused: 'register',
    notRobot: null,
  }

  componentDidMount() {
    gaPageView()
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.passwordErrMessage !== prevProps.passwordErrMessage ||
      this.props.phoneErrMessage !== prevProps.phoneErrMessage ||
      this.props.usernameErrMessage !== prevProps.usernameErrMessage ||
      this.props.emailErrMessage !== prevProps.emailErrMessage
    ) {
      this.props.isDisabledRegister()
    }
  }

  componentWillUnmount() {
    this.props.reset()
  }

  inputHandleClick = focusedInput => event => {
    event.preventDefault()
    event.stopPropagation()
    this.props.focusInput(focusedInput)
  }

  handleChange = e => {
    const key = e.target.value
    this.props.updateInput(key)
  }

  register = event => {
    event.preventDefault()
    event.stopPropagation()
    if (!this.state.notRobot) {
      this.setState({ notRobot: false })

      return null
    }

    this.props.register(
      this.props.username,
      this.props.email,
      this.props.password,
      this.props.phone,
      this.props.refferalId
    )
  }

  _getSourceQuery = () => {
    let source = []
    if (this.props.matches && this.props.matches.src) {
      source.push(`src=${this.props.matches.src}`)
      if (this.props.matches.ctgid) {
        source.push(`ctgid=${this.props.matches.ctgid}`)
      }
      if (this.props.matches.subid) {
        source.push(`subid=${this.props.matches.subid}`)
      }
      if (this.props.matches.tid) {
        source.push(`tid=${this.props.matches.tid}`)
      }
      if (this.props.matches.id) {
        source.push(`id=${this.props.matches.id}`)
      }
    }
    return source.join('&')
  }

  onSuccess = () => {
    this.props.reset()
    route(`${__webpack_public_path__ || '/'}register/confirmation`)
  }

  registerFacebook = (id, email, username) => {
    const timestamp = new Date().getTime()

    this.props.focusInput(REGISTER_INPUT_USERNAME)
    this.props.updateInput(username)
    this.props.verifyUsername(username, timestamp)

    this.props.focusInput(REGISTER_INPUT_EMAIL)
    this.props.updateInput(email)
    this.props.verifyEmail(email, timestamp)
  }

  setNotRobot = notRobot => {
    this.setState({ notRobot })
  }

  onValidateUsername = debounce(e => {
    const username = e.target.value
    const timestamp = new Date().getTime()

    this.handleChange(e)
    this.props.verifyUsername(username, timestamp)
  }, 200)

  onValidateEmail = debounce(e => {
    const email = e.target.value
    const timestamp = new Date().getTime()

    this.handleChange(e)
    this.props.verifyEmail(email, timestamp)
  }, 200)

  onVerifyRefferalId = debounce(e => {
    const refferalId = e.target.value
    const timestamp = new Date().getTime()

    debounce(this.props.verifyRefferalId(refferalId, timestamp), 20000)
  }, 200)

  onVerifyPassword = debounce(e => {
    const email = e.target.value

    this.handleChange(e)
    this.props.verifyPassword(email)
  }, 200)

  onVerifyPhone = debounce(e => {
    const phone = e.target.value

    this.handleChange(e)
    this.props.verifyPhone(phone)
  })

  render({ polyglot: { t } }) {
    if (this.props.removeRegister || this.props.isLoggedIn) {
      return <Redirect to={`${__webpack_public_path__ || '/'}`} />
    }

    if (this.props.status === REGISTER_STATUS_SUCCESS) {
      this.onSuccess()
    }

    return (
      <div className="component">
        <div className="componentBody">
          <div className={styles.registerAppbar}>
            <AppBar
              title={t('tv_auth.title_register', { _: 'Register a New Account' })}
              subtitle={t('tv_auth.subtitle_register', {
                _: 'to continue with %{app_name}',
                app_name: this.props.appName,
              })}
            />
          </div>

          <div className={styles.container}>
            <div className={styles['register-container']}>
              <div className={styles['register-form']}>
                <div className={styles['block-title']}>Sign Up with:</div>
                <div className={styles['form-control']}>
                  <SocialAuth onFacebookSuccess={this.registerFacebook} />
                </div>

                <div className={styles['block-title']}>
                  Sign Up with Email Address:
                </div>
                {this.state.notRobot === false && (
                  <div className={styles['message--alert']}>
                    {t('tv_auth.not_a_robot', {
                      _: 'Please confirm if you are not a robot!',
                    })}
                  </div>
                )}
                <div className={styles['form-control']}>
                  <input
                    type="hidden"
                    placeholder={t('tv_auth.refferal_id', {
                      _: 'Referral ID (Optional)',
                    })}
                    value={this.props.refferalId}
                    onChange={this.onVerifyRefferalId}
                    onFocus={this.inputHandleClick(REGISTER_INPUT_REFFERAL_ID)}
                    onClick={this.inputHandleClick(REGISTER_INPUT_REFFERAL_ID)}
                  />
                  {this.props.refferalIdErrMessage && (
                    <div className={styles['alert-field']}>
                      {this.props.refferalIdErrMessage}
                    </div>
                  )}
                </div>

                <div
                  className={classnames(styles['form-control'], {
                    [styles['form--mandatory']]:
                      this.props.usernameErrMessage ||
                      this.props.usernameErrMessage === null,
                    [styles['form--success']]:
                      !this.props.usernameErrMessage &&
                      this.props.usernameErrMessage !== null,
                  })}
                >
                  <input
                    type="text"
                    placeholder={t('tv_auth.label_username', { _: 'Username' })}
                    value={this.props.username}
                    onChange={this.onValidateUsername}
                    onFocus={this.inputHandleClick(REGISTER_INPUT_USERNAME)}
                    onClick={this.inputHandleClick(REGISTER_INPUT_USERNAME)}
                  />
                  {this.props.usernameErrMessage && (
                    <div className={styles['alert-field']}>
                      {this.props.usernameErrMessage}
                    </div>
                  )}
                </div>

                <div
                  className={classnames(styles['form-control'], {
                    [styles['form--mandatory']]:
                      this.props.emailErrMessage || this.props.emailErrMessage === null,
                    [styles['form--success']]:
                      !this.props.emailErrMessage && this.props.emailErrMessage !== null,
                  })}
                >
                  <input
                    type="email"
                    placeholder={t('tv_auth.label_email', { _: 'Email Address' })}
                    value={this.props.email}
                    onChange={this.onValidateEmail}
                    onFocus={this.inputHandleClick(REGISTER_INPUT_EMAIL)}
                    onClick={this.inputHandleClick(REGISTER_INPUT_EMAIL)}
                  />
                  {this.props.emailErrMessage && (
                    <div className={styles['alert-field']}>
                      {this.props.emailErrMessage}
                    </div>
                  )}
                </div>

                <div
                  className={classnames(styles['form-control'], {
                    [styles['form--mandatory']]:
                      this.props.passwordErrMessage ||
                      this.props.passwordErrMessage === null,
                    [styles['form--success']]:
                      !this.props.passwordErrMessage &&
                      this.props.passwordErrMessage !== null,
                  })}
                >
                  <input
                    type="password"
                    placeholder={t('tv_auth.label_password', { _: 'Password' })}
                    value={this.props.password}
                    onChange={this.onVerifyPassword}
                    onFocus={this.inputHandleClick(REGISTER_INPUT_PASSWORD)}
                    onClick={this.inputHandleClick(REGISTER_INPUT_PASSWORD)}
                  />
                  {this.props.passwordErrMessage && (
                    <div className={styles['alert-field']}>
                      {this.props.passwordErrMessage}
                    </div>
                  )}
                </div>

                <div
                  className={classnames(styles['form-control'], {
                    [styles['form--mandatory']]:
                      this.props.phoneErrMessage || this.props.phoneErrMessage === null,
                    [styles['form--success']]:
                      !this.props.phoneErrMessage && this.props.phoneErrMessage !== null,
                  })}
                >
                  <input
                    type="text"
                    placeholder={t('tv_auth.phone', { _: 'Phone Number' })}
                    value={this.props.phone}
                    onChange={this.onVerifyPhone}
                    onFocus={this.inputHandleClick(REGISTER_INPUT_PHONE)}
                    onClick={this.inputHandleClick(REGISTER_INPUT_PHONE)}
                  />
                  {this.props.phoneErrMessage && (
                    <div className={styles['alert-field']}>
                      {this.props.phoneErrMessage}
                    </div>
                  )}
                </div>

                <div className={styles['form-control']}>
                  <Recaptcha setNotRobot={this.setNotRobot} />
                </div>

                <button
                  className={styles.registerBtn}
                  type="submit"
                  onClick={this.register}
                  disabled={this.props.disableButton}
                >
                  Create Account
                </button>
                <p className={styles['register-terms']}>
                  By creating an account you are agreeing with our <br />
                  {!this.props.removeRegister && (
                    <Link
                      className={styles['register-terms__link']}
                      href={`${__webpack_public_path__ ||
                        '/'}settings/terms-of-use?src=register`}
                    >
                      Terms of Use
                    </Link>
                  )}{' '}
                  and the{' '}
                  {!this.props.removeRegister && (
                    <Link
                      className={styles['register-terms__link']}
                      href={`${__webpack_public_path__ ||
                        '/'}settings/privacy-policy?src=register`}
                    >
                      Privacy Policy.
                    </Link>
                  )}
                </p>
              </div>

              <div className={styles['login-block']}>
                <div>Already have an account?</div>
                {!this.props.removeRegister && (
                  <div className={styles.login}>
                    <Link
                      href={`${__webpack_public_path__ ||
                        '/'}auth/login?${this._getSourceQuery()}`}
                    >
                      Login
                    </Link>
                  </div>
                )}
              </div>
            </div>
            <ListingText />
          </div>
        </div>
        {this.props.status === REGISTER_STATUS_FAILED ? (
          <Modal isFocused={false}>
            <div className={modalStyles.content}>
              <div className={modalStyles.title}>
                {t('tv_auth.register_failed_title', { _: 'Register failed!' })}
              </div>
              <div className={modalStyles.message}>
                {t('tv_auth.register_failed_description', {
                  _: 'Please check your account details and try again.',
                })}
              </div>
            </div>
            <div className={modalStyles.btns}>
              <div
                className={modalStyles.btn}
                onClick={() => this.props.setStatus(REGISTER_STATUS_WAITING)}
              >
                {t('tv_auth.button_ok', { _: 'OK' })}
              </div>
            </div>
          </Modal>
        ) : null}
        {this.props.status === REGISTER_STATUS_PROCESSING ? (
          <Modal isFocused={true}>
            <div className={modalStyles.content}>
              <div className={modalStyles.title}>
                {t('tv_auth.register_processing', {
                  _: 'Registering your account, please wait ...',
                })}
              </div>
            </div>
          </Modal>
        ) : null}
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isLoggedIn: isLoggedIn(state),
  status: getStatus(state),
  focusedInput: getFocusedInput(state),
  username: getUsername(state),
  email: getEmail(state),
  password: getPassword(state),
  refferalId: getRefferalId(state),
  phone: getPhone(state),
  usernameError: getUsernameError(state),
  emailError: getEmailError(state),
  polyglot: getP(state),
  appName: getAppName(state),
  removeRegister: selectRemoveRegister(state),
  passwordErrMessage: getPasswordErrMessage(state),
  phoneErrMessage: getPhoneErrMessage(state),
  usernameErrMessage: getUsernameErrMessage(state),
  emailErrMessage: getEmailErrMessage(state),
  refferalIdErrMessage: getRefferalIdMessage(state),
  disableButton: getDisableButton(state),
})

const mapDispatchToProps = {
  focusInput,
  updateInput,
  register,
  setStatus,
  reset,
  verifyEmail,
  verifyRefferalId,
  verifyUsername,
  verifyPassword,
  verifyPhone,
  isDisabledRegister,
}

export default connect(mapStateToProps, mapDispatchToProps)(Register)
